import { useCallback } from "react"

import { Dialog, DialogContent } from "@mui/material"

import { AgreementResult } from "interface/agreement"
import { AgreementPreview } from "../components/preview"

type AgreementOpenPreviewDialogProps = {
  agreement: AgreementResult
  onAgree: (version: number) => void
  onClose: () => void
}
export const AgreementOpenPreviewDialog = ({
  agreement,
  onAgree,
  onClose
}: AgreementOpenPreviewDialogProps) => {
  const onClickAgree = useCallback(
    () => {
      onAgree(agreement.version)
    },
    [onAgree, agreement]
  )
  return (
    <Dialog
      open
      fullWidth
      maxWidth='md'
      onClose={() => onClose()}
    >
      <DialogContent
        sx={{
          padding: 0,
          height: '80vh',
          position: 'relative'
        }}
      >
        <AgreementPreview
          agreement={agreement}
          onClickAgree={onClickAgree}
          onClose={onClose}
          height="100%"
        />
      </DialogContent>
    </Dialog>
  )
}